import { mapGetters, mapActions } from 'vuex';
import { isArray } from 'util';

export default {

  component: {
  },

  data() {
    return {
      showInstall: false,
      installEvent: null,
      downlaodInProgress: false,
      remainingFilesToCache: [],
      totalFilesToCache: 0,
      cacheNames: [],
      batchSize: 25,
    }
  },

  computed: {
    ...mapGetters([
      'menu',
    ]),
  },

  methods: {

    ...mapActions({
    }),

    clicInstall(choice) {
      this.showInstall = false;
      // Show the modal add to home screen dialog
      installEvent.prompt();
      // Wait for the user to respond to the prompt
      installEvent.userChoice.then((choice) => {
        if (choice.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        // Clear the saved prompt since it can't be used again
        installEvent = null;
      });
    },

  },

  watch: {
    'showInstall'() {
      if (this.showInstall === true) {
        this.$toasted.show("Installez l'application LG Ventes !", {
          theme: "bubble",
          position: "bottom-left",
          duration : null,
          icon: {
            name : 'download'
          },
          action : [
            {
              text : 'Installer',
              // router navigation
              onClick : (e, toastObject) => {
                toastObject.goAway(0);
                // Show the modal add to home screen dialog
                this.installEvent.prompt();
                // Wait for the user to respond to the prompt
                this.installEvent.userChoice.then((choice) => {
                  if (choice.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                    window.addEventListener("beforeunload", this.confirmationMessageHandle);
                  } else {
                    console.log('User dismissed the A2HS prompt');
                  }
                  // Clear the saved prompt since it can't be used again
                  this.installEvent = null;
                });
                this.showInstall = false;
              }
            },
            {
              text : 'Annuler',
              onClick : (e, toastObject) => {
                toastObject.goAway(0);
              }
            },
          ]
        });
      } else {
        this.$toasted.clear();
      }
    }
  },

  created() {
    window.addEventListener('beforeinstallprompt', event => {
      event.preventDefault();
      this.installEvent = event;
      this.showInstall = true;
    });

  }
};